export const Modes = {
    CREATE: 'CREATE',
    EDIT: 'EDIT'
};

export const Frequency = {
    WEEKLY: 'weekly',
    SEMIMONTHLY: 'semimonthly',
    MONTHLY: 'monthly',
    NEVER: 'never'
};
